import { useQuery } from '@mint-lib/query-client';
import { Auth } from '@mint-sdk/api-auth';

const useUsersData = () => {
  return useQuery({
    ...Auth.listAllUsers({ params: { limit: 0 } }),
    staleTime: Infinity,
  });
};

export default useUsersData;
